var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fa m-1 text-bigger",class:_vm.checked ? 'fa-check-square-o text-success' : 'fa-square-o'})
}
var staticRenderFns = []

export { render, staticRenderFns }